import { useMemo } from "react";
import {
  createGarantieFinanciereIasSchema2025,
  GarantieFinanciereIasFormValues2025,
} from "../schemas/ConformiteGarantieFinanciereIasSchema2025";
import {
  createGarantieFinanciereIasSchema2026,
  GarantieFinanciereIasFormValues2026,
} from "../schemas/ConformiteGarantieFinanciereIasSchema2026";
import {
  createGarantieFinanciereIobspSchema2025,
  GarantieFinanciereIobspFormValues2025,
} from "../schemas/ConformiteGarantieFinanciereIobspSchema2025";
import {
  createGarantieFinanciereIobspSchema2026,
  GarantieFinanciereIobspFormValues2026,
} from "../schemas/ConformiteGarantieFinanciereIobspSchema2026";

/**
 * Type union pour les valeurs du formulaire IAS
 */
export type GarantieFinanciereIasFormValues =
  | GarantieFinanciereIasFormValues2025
  | GarantieFinanciereIasFormValues2026;

/**
 * Type union pour les valeurs du formulaire IOBSP
 */
export type GarantieFinanciereIobspFormValues =
  | GarantieFinanciereIobspFormValues2025
  | GarantieFinanciereIobspFormValues2026;

/**
 * Hook personnalisé pour sélectionner automatiquement le bon schéma
 * de validation selon le millésime et le type de garantie financière
 *
 * @param millesime - Le millésime pour lequel le schéma doit être sélectionné
 * @param type - Le type de garantie financière ('ias' ou 'iobsp')
 * @returns Le schéma de validation approprié
 *
 * @example
 * ```tsx
 * const schema = useGarantieFinanciereSchema(2026, 'ias');
 * const formConfig = useFormConfig({ schema, defaultValues: {...} });
 * ```
 */
export function useGarantieFinanciereSchema(
  millesime: number,
  type: "ias" | "iobsp"
) {
  const schema = useMemo(() => {
    if (type === "ias") {
      return millesime < 2026
        ? createGarantieFinanciereIasSchema2025(millesime)
        : createGarantieFinanciereIasSchema2026(millesime);
    }
    return millesime < 2026
      ? createGarantieFinanciereIobspSchema2025(millesime)
      : createGarantieFinanciereIobspSchema2026(millesime);
  }, [millesime, type]);

  return schema;
}
